const encode = encodeURIComponent
const decode = decodeURIComponent

function parse(url = location.search) {
  const obj = {}
  const arr = url.match(new RegExp('[?&][^?&]+=[^?&]+', 'g'))
  if (arr) {
    arr.forEach((item) => {
      const pairs = item.substring(1).split('=')
      const key = decodeURIComponent(pairs[0])
      const val = decodeURIComponent(pairs[1])
      obj[key] = val
    })
  }
  return obj
}

function appendQuery(url, params) {
  let appendedUrl = url
  if (appendedUrl.indexOf('?') === -1) {
    appendedUrl = `${appendedUrl}?`
  }
  if (Array.isArray(params)) {
    appendedUrl = `${appendedUrl}&${params.join('&')}`
  } else {
    const keys = Object.keys(params)
    const paramsArr = []

    keys.forEach((key) => {
      paramsArr.push(
        `${key}=${encodeURIComponent(params[key])}`
      )
    })

    appendedUrl = `${appendedUrl}&${paramsArr.join('&')}`
  }
  return appendedUrl
}

function stringify(urlP, paramsObj) {
  let url = urlP
  const paramsArr = []
  const paramKeys = Object.keys(paramsObj)
  paramKeys.forEach((param) => {
    paramsArr.push(
      `${param}=${encodeURIComponent(paramsObj[param])}`
    )
  })

  if (paramsArr.length > 0) {
    if (url.indexOf('?') > -1) {
      url += '&'
    } else {
      url += '?'
    }
    url += paramsArr.join('&')
  }

  return url
}

function urlHash(index) {
  const url = window.location.hash
  if (!url) {
    return ''
  }
  const hash = url.split('?')[0]
  const hashPath = hash.split('/')
  if (index < hashPath.length - 1) {
    return hashPath[index + 1]
  }
  return ''
}

function normalLang(lang) {
  let normalResult = ''
  const detailLang = lang.split('-')
  normalResult = detailLang[0].toLowerCase()
  if (detailLang.length > 1) {
    normalResult = `${normalResult}-${detailLang[1].toUpperCase()}`
  }
  return normalResult
}

function parseQuery (query) {
  const res = {}
  query = query.trim().replace(/^(\?|#|&)/, '')

  if (!query) {
    return res
  }
  query.split('&').forEach(param => {
    const parts = param.replace(/\+/g, ' ').split('=')
    const key = decode(parts.shift())
    const val = parts.length > 0 ? decode(parts.join('=')) : ''

    if (key === '') {
      return false
    }
    if (res[key] === undefined) {
      res[key] = val
    } else if (Array.isArray(res[key])) {
      res[key].push(val)
    } else {
      res[key] = val
    }
  })
  return res
}

// 解析字符串为字典格式
function resolveQuery (query, extraQuery = {}) {
  if (query) {
    let parsedQuery = {}
    let index = query.indexOf('?')
    query = index !== -1 ? query.slice(query.indexOf('?') + 1) : ''
    query = query.replace(/(\?|#\/)/g, '&')
    try {
      parsedQuery = parseQuery(query)
    } catch (e) {
      parsedQuery = {}
    }
    for (const key in extraQuery) {
      parsedQuery[key] = extraQuery[key]
    }
    return parsedQuery
  } else {
    return extraQuery
  }
}

// 将字典格式拼接成字符串，带“?”
function stringifyQuery (obj) {
  const res = obj ? Object.keys(obj).sort().map(key => {
    const val = obj[key]
    if (val === undefined) {
      return ''
    }
    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      const result = []
      val.slice().forEach(val2 => {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key))
        } else {
          result.push(encode(key) + '=' + encode(val2))
        }
      })
      return result.join('&')
    }
    return encode(key) + '=' + encode(val)
  }).filter(x => x.length > 0).join('&') : null
  return res ? `?${res}` : ''
}

// 拼接当前location的query
function concatLocalQuery (url = '', json = {}) {
  var objUrlQuery = resolveQuery(url)
  var objLocalQuery = resolveQuery(location.href)
  var newObjQuery = Object.assign({}, objUrlQuery, objLocalQuery, json)
  var strNewQuery = stringifyQuery(newObjQuery)
  var index = url.indexOf('?')
  return (index !== -1 ? url.slice(0, index) : url.slice(0)) + strNewQuery
}

function go (path, params = {}, isReplace) {
  const extendParams = {
    ...parse(location.search),
    ...parse(location.hash),
    ...params
  }
  const urlToGo = appendQuery(path, extendParams)

  setTimeout(() => {
    if (isReplace) {
      location.replace(urlToGo)
    } else {
      location.href = urlToGo
    }
  }, 5)
}

function filterObject(obj) {
  const res = {}
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key]
      if (value !== undefined && value !== null) {
        res[key] = value
      }
    }
  }
  return res
}

export default {
  parse,
  appendQuery,
  go,
  stringify,
  urlHash,
  normalLang,
  resolveQuery,
  stringifyQuery,
  concatLocalQuery,
  filterObject
}
